import {
  DeviceCategoryEnum,
  DeviceType,
  DeviceTypeEnum,
  deviceCategoryData
} from '@/constants/deviceManage';

// 是否是非3.0昆仑山设备
export const isNotKlsV3Aeb = (deviceCategory: string | number) => {
  if (deviceCategory) {
    // 将设备类型转为数值类型数据
    const numberDeviceCategory = Number(deviceCategory);
    return DeviceCategoryEnum.kunlunshan === numberDeviceCategory;
  } else {
    return false;
  }
};

// 是否是昆仑山3.0设备
export const isKlsV3Aeb = (deviceCategory: string | number) => {
  if (deviceCategory) {
    // 将设备类型转为数值类型数据
    const numberDeviceCategory = Number(deviceCategory);
    return DeviceCategoryEnum.kunlunshanV3 === numberDeviceCategory ;
  } else {
    return false;
  }
};

// 是否是领行
export const isLingXing = (deviceCategory: string | number) => {
  if (deviceCategory) {
    // 将设备类型转为数值类型数据
    const numberDeviceCategory = Number(deviceCategory);
    return DeviceCategoryEnum.lingxing === numberDeviceCategory;
  } else {
    return false;
  }
};

// 是否是畅行
export const isChangxing = (deviceCategory: string | number) => {
  if (deviceCategory) {
    // 将设备类型转为数值类型数据
    const numberDeviceCategory = Number(deviceCategory);
    return DeviceCategoryEnum.changxing === numberDeviceCategory;
  } else {
    return false;
  }
};

// 是否是安行（基于具体设备型号判断，而非设备大类）
export const isAnXing = (deviceType?: string | number | null) => {
  if (deviceType === undefined || deviceType === null || deviceType === '') {
    return false;
  }
  return Number(deviceType) === DeviceTypeEnum.TLY50F4001;
};

// 是否是黄河设备
export const isHhAeb = (deviceCategory: string | number) => {
  if (deviceCategory) {
    // 将设备类型转为数值类型数据
    const numberDeviceCategory = Number(deviceCategory);
    return DeviceCategoryEnum.huanghe === numberDeviceCategory;
  } else {
    return false;
  }
};

// 是否为昆仑山设备(昆仑山设备、昆仑山3.0设备两种)
export const isKlsAeb = (deviceCategory: string | number) => {
  if (deviceCategory) {
    return isNotKlsV3Aeb(deviceCategory) || isKlsV3Aeb(deviceCategory) || isLingXing(deviceCategory) || isChangxing(deviceCategory);
  } else {
    return false;
  }
};

// 显示设备类型
export const displayDeviceTypeCategory = (deviceCategory: number | null) => {
  const matchData: DeviceType | undefined = deviceCategoryData.find(
    (item: DeviceType) => item.value === deviceCategory
  );
  return matchData?.label || deviceCategory;
};
